// @flow

import React from 'react';

const Iframe = ({ iframe } : { iframe: String }) => (
  <React.Fragment>
    <div dangerouslySetInnerHTML={{ __html: iframe }} />
  </React.Fragment>
);

export default Iframe;



// WEBPACK FOOTER //
// ./src/components/main/specialDeals/iframe.js